export default "__VITE_ASSET__CLE9mG1w__"